import { fetchJSON } from './utils'

export default async function news() {
    return fetchJSON(`/api/news`, {})
}
